import React from 'react';
import './index.scss';
import { ButtonLink, Icon, PhoneLine } from 'dyl-components';
import { Grid, GridColumn } from 'semantic-ui-react';

const OfficeViewAdditionalLines = ({ additionalLineSpace, lines = [], currentTime , onSelectCall, onUnholdCall, onAnswer, onReject, answerDisabled, isExpanded, toggleExpansion, userPhoneCreds }) => {
    return (
        <div style={{ height: 30, width: "100%", position: 'relative', overflow: "visible" }}>
            <div 
                className={`OfficeView__additionalLines ${isExpanded ? `OfficeView__additionalLines--expanded${additionalLineSpace ? `-${additionalLineSpace}` : ""}` : ""}`}
            >
                <span style={{ flex: 1 }}>Additional Lines</span>
                <ButtonLink style={{float: 'right', ...(!isExpanded && { marginTop: 6 })}} onClick={toggleExpansion}>
                    <Icon className={`fa-solid fa-circle-chevron-${isExpanded ? "down" : "up"}`} />
                </ButtonLink>
                {isExpanded && (
                    <Grid style={{marginTop: 1}}>
                        {lines.map((line) => (
                            <GridColumn width={8} key={line.call_type === "transfer" ? line.channel_uuid : line.uuid}>
                                <PhoneLine
                                    line={line}
                                    currentTime={currentTime}
                                    onSelectCall={onSelectCall}
                                    onUnholdCall={onUnholdCall}
                                    onAnswer={onAnswer}
                                    onReject={onReject}
                                    answerDisabled={answerDisabled} 
                                    userPhoneCreds={userPhoneCreds}
                                />
                            </GridColumn>
                        ))}
                    </Grid>
                )}
            </div>
        </div>
    )
}

export default OfficeViewAdditionalLines;

